import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-service-offer',
  templateUrl: './service-offer.component.html',
  styleUrls: ['./service-offer.component.scss'],
})
export class ServiceOfferComponent  {

  loader:boolean = false;

  constructor(public service: ApiService, public handler: HandlerService, public router: Router,private bottomSheet: MatBottomSheet,public auth:AuthService) { }


  details() {
    this.router.navigate(['/offer-details']);
  }

}
